<template>
    <PopupRouterViewDetail label="Putaway Configuration Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Putaway Configuration" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-radio :options="putAwayCategorys" text-field="name" value-field="id" label-cols-lg="12" label="Putaway Category" id="fieldset-putaway-category" size="sm" :model.sync="model.putawayCategoryId"  @change="updateData" :isUpdatable ="true"/>
						<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Area" id="fieldset-area" size="sm" :model.sync="model.areaId" :isRequired="true" :state="validateState('areaId')" :errorMessage="getErrorMessage(errorMessage.areaId, 'areaId')"   :selected="model.area != null ? model.area.code : ''" @input="getAreas" @change="updateData" :isUpdatable ="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedArea" />
						<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Next Area" id="fieldset-next-area" size="sm" :model.sync="model.nextAreaId" :isRequired="true" :state="validateState('nextAreaId')" :errorMessage="getErrorMessage(errorMessage.nextAreaId, 'nextAreaId')"   :selected="model.nextArea != null ? model.nextArea.code : ''" @input="getAreas" @change="updateData" :isUpdatable ="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedNextArea" />
						<app-input-combobox-autocomplete :options="partClassifications" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Part Classification" id="fieldset-part-classification" size="sm" :model.sync="model.partClassificationId"   :selected="model.partClassification != null ? model.partClassification.code : ''" @input="getPartClassifications" @change="updateData" :isUpdatable ="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedPartClassification" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PutawayConfiguration from '@/models/PutawayConfiguration/PutawayConfiguration';
import PutawayConfigurationList from '@/models/PutawayConfiguration/PutawayConfigurationList';
import PutawayConfigurationFilter from '@/filters/PutawayConfiguration/PutawayConfigurationFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputRadio from '@/components/AppInputRadio';
import PutAwayCategory from '@/models/PutAwayCategory/PutAwayCategory';
import PutAwayCategoryFilter from '@/filters/PutAwayCategory/PutAwayCategoryFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Area from '@/models/Area/Area';
import AreaFilter from '@/filters/Area/AreaFilter';
import PartClassification from '@/models/PartClassification/PartClassification';
import PartClassificationFilter from '@/filters/PartClassification/PartClassificationFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputRadio,
		AppInputComboboxAutocomplete,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			areaId: {required},
			nextAreaId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				areaId: { required : "Area is Required."},
				nextAreaId: { required : "Next Area is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterPutawayConfiguration : null,
			currentPutawayConfigurationPage : 1,
			putawayConfigurationPageSize: 10,
			sortByPutawayConfiguration: '',
			sortDescPutawayConfiguration: '',
			putAwayCategorys: [],
			putawayCategorys: [],
			isPutawayCategoryComboLoading: false,
			areas: [],
			areas: [],
			isAreaComboLoading: false,
			partClassifications: [],
			partClassifications: [],
			isPartClassificationComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isPutAwayCategoryComboLoading: false,
			isAreaComboLoading: false,
			isPartClassificationComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getPutawayConfiguration : async function(id) {
			this.isBusy = true;
			PutawayConfiguration.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPutawayConfiguration = true;
			this.filterPutawayConfiguration.id = this.modelId;
			PutawayConfiguration.downloadDataDetail(this, this.filterPutawayConfiguration).then(result => {
				this.isDownloadPutawayConfiguration = false;
			}).catch(error => { this.isDownloadPutawayConfiguration = false; })
		},
		getPutawayConfigurations : async function(input) {
			let filter = new PutawayConfigurationFilter();
			if (input != undefined) {
				filter.PutawayCategory = input;
			}
			this.isPutawayConfigurationComboLoading = true;
			PutawayConfiguration.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.putawayConfigurations = result.data
				}
				this.isPutawayConfigurationComboLoading = false;
			})
			.catch(error => {});
		},
		getPutAwayCategorys : async function(input) {
			let filter = new PutAwayCategoryFilter();
			if (input != undefined) {
				filter.name = input;
			}
			PutAwayCategory.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.putAwayCategorys = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPutawayCategory(item) {
			if(item == undefined || item == null) {
				this.model.putawayCategoryId = null;
				this.model.putawayCategory = null;
			} else {
				this.model.putawayCategoryId = item.id;
				this.model.putawayCategory = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getAreas : async function(input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Area.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.areas = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedArea(item) {
			if(item == undefined || item == null) {
				this.model.areaId = null;
				this.model.area = null;
			} else {
				this.model.areaId = item.id;
				this.model.area = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedNextArea(item) {
			if(item == undefined || item == null) {
				this.model.nextAreaId = null;
				this.model.nextArea = null;
			} else {
				this.model.nextAreaId = item.id;
				this.model.nextArea = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getPartClassifications : async function(input) {
			let filter = new PartClassificationFilter();
			if (input != undefined) {
				filter.code = input;
			}
			PartClassification.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partClassifications = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPartClassification(item) {
			if(item == undefined || item == null) {
				this.model.partClassificationId = null;
				this.model.partClassification = null;
			} else {
				this.model.partClassificationId = item.id;
				this.model.partClassification = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.putawayConfigurationInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						PutawayConfiguration.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'putawayconfigurationindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						PutawayConfiguration.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'putawayconfigurationindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData(state) {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PutawayConfiguration.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getPutawayConfiguration(id);
					});
				}
			});
		},
		onHidden() {
			this.getPutawayConfigurations();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterPutawayConfiguration = new PutawayConfigurationFilter();
		this.getPutAwayCategorys();
		//this.getAreas();
		//this.getPartClassifications();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPutawayConfiguration(id);
			} else {
				this.modelId = id;
				this.getPutawayConfiguration(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
